import { render, staticRenderFns } from "./DocumentListItem.vue?vue&type=template&id=f7cde99a"
import script from "./DocumentListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentListItem.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports